export default __webpack_public_path__ + "static/media/element.8e6aa822.svg";